import { render, staticRenderFns } from "./TopList3.vue?vue&type=template&id=2abd0c34"
import script from "./TopList3.vue?vue&type=script&lang=js"
export * from "./TopList3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports